import { useMemo } from "react";
import format from "date-fns/format";
import { faMobileAlt } from "@fortawesome/free-solid-svg-icons/faMobileAlt";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MONTH_DAY_YEAR_HOUR_MINUTE_DATE_FORMAT } from "@constants/date-formats";
import { AttributeTypes } from "@iddataweb/idw-common-ui/enums";
import { LabelWidthTypes } from "@enums/label-width-types";
import { AXNUIContent } from "@iddataweb/idw-common-ui/types";
import { FormattedRpServiceConfigurationAttribute } from "@idw-types/data/rp-service-configuration";
import { IdwFormLabel } from "../../idw-form-label/idw-form-label";
import styles from "./axnui-theming-async-input-component.less";

type AXNUIThemingAsyncInputComponentProps = {
    attribute: FormattedRpServiceConfigurationAttribute;
    isRequired: boolean;
    label: string;
    showAfterCapturePreview: boolean;
    axnuiContent: AXNUIContent;
};

export const AXNUIThemingAsyncInputComponent = (props: AXNUIThemingAsyncInputComponentProps) => {
    const { attribute, isRequired, label, showAfterCapturePreview, axnuiContent } = props;

    const isMultiImageInput = useMemo(() => {
        return [AttributeTypes.DRIVERS_LICENSE_IMAGES, AttributeTypes.PAN_IMAGES, AttributeTypes.AADHAR_CARD_IMAGES, AttributeTypes.ID_CARD_IMAGES].includes(attribute.attributeType.name);
    }, [attribute.attributeType.name]);

    return (
        <div>
            <IdwFormLabel isRequired={isRequired} label={label} labelWidth={LabelWidthTypes.EXTRA_SMALL} />
            <div id={`async-attr-${attribute.attributeType.id}`} className={styles.axnuiThemingAsyncInputComponent}>
                {!showAfterCapturePreview && (
                    <>
                        <div className={styles.asyncMobile}>
                            <FontAwesomeIcon icon={faMobileAlt} className={styles.mobileIcon} />
                            {axnuiContent.form.asyncInput.captureMessage}
                        </div>
                        <div className={styles.statusDiv}>
                            <span className={styles.statusText}>{axnuiContent.form.asyncInput.status}:</span>
                            <span id={`async-status-value-${attribute.attributeType.id}`}>
                                {axnuiContent.form.asyncInput.incompleteStatus}
                            </span>
                        </div>
                    </>
                )}
                {showAfterCapturePreview && (
                    <>
                        <label>
                            {isMultiImageInput ? axnuiContent.form.imageAttribute.previewTextMultiple : axnuiContent.form.imageAttribute.previewTextSingle}
                        </label>
                        <div className={styles.imagePreviewContainer}>
                            <div className={styles.imagePreview}>{isMultiImageInput ? "Front Image" : "Image"}</div>
                            {isMultiImageInput && (
                                <div className={styles.imagePreview}>Back Image</div>
                            )}
                        </div>
                        <span className="async-masked" id={`async-masked-value-${attribute.id}`}>
                            {label} {format(new Date(), MONTH_DAY_YEAR_HOUR_MINUTE_DATE_FORMAT)}
                        </span>
                        <div className={styles.statusDiv}>
                            <span className={styles.statusText}>{axnuiContent.form.asyncInput.status}:</span>
                            <span id={`async-status-value-${attribute.attributeType.id}`}>
                                {axnuiContent.form.asyncInput.completeStatus}
                                <FontAwesomeIcon className={styles.checkIcon} icon={faCheck} />
                            </span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
